import { baseFetch, getUrlWithSearchParams } from "@helium10/re-core";
import { apiData } from "../consts/links";
export const getData = async (params, signal) => {
    return await baseFetch({
        url: getUrlWithSearchParams(apiData, {}),
        params: {
            ...(params?.offer && { offer: params?.offer }),
            ...(params?.coupon && { coupon: params?.coupon }),
            ...(params?.items && { items: JSON.stringify(params?.items) }),
        },
        signal,
    }).then(transform);
};
const transform = (response) => response?.data;
